/* tslint:disable */
/* eslint-disable */
/* @relayHash a0a22d39055dd973a1a6c92ef488db1f */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type types = "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type sbRespRootQueryVariables = {
    userId?: string | null;
    fetchUser: boolean;
    uriRef?: string | null;
    first: number;
    page: number;
    localeOrigin?: string | null;
    isTrade: boolean;
    showSeller: boolean;
    followSearchPages?: Array<string | null> | null;
    followSearchTypes?: Array<types | null> | null;
    contentModuleId?: string | null;
    eligibleAbTest?: string | null;
    regions?: string | null;
    userZipCode?: string | null;
    userCountryCode?: string | null;
    fetchRegionalInfo?: boolean | null;
    isClient: boolean;
    fetchSb: boolean;
    disableForceFacet?: boolean | null;
    localRecentHistoryItemIds?: Array<string | null> | null;
    fetchUserRecentHistoryItem?: boolean | null;
    isSbTileCarouselTest?: boolean | null;
};
export type sbRespRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"getDomainLinksSb_viewer" | "SbRespLayout_viewer" | "detectPageExistsAndRedirect_viewer">;
    };
};
export type sbRespRootQuery = {
    readonly response: sbRespRootQueryResponse;
    readonly variables: sbRespRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUser",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "uriRef",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "localeOrigin",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "showSeller",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchPages",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchTypes",
    "type": "[types]",
    "defaultValue": [
      "SEARCH"
    ]
  },
  {
    "kind": "LocalArgument",
    "name": "contentModuleId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "eligibleAbTest",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "regions",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userZipCode",
    "type": "String",
    "defaultValue": "0"
  },
  {
    "kind": "LocalArgument",
    "name": "userCountryCode",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "fetchRegionalInfo",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "isClient",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchSb",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "disableForceFacet",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "localRecentHistoryItemIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUserRecentHistoryItem",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "isSbTileCarouselTest",
    "type": "Boolean",
    "defaultValue": false
  }
],
v1 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "contentModuleId",
    "variableName": "contentModuleId"
  }
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v8 = [
  (v4/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "versions",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "webPath",
      "args": null,
      "storageKey": null
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vertical",
  "args": null,
  "storageKey": null
},
v18 = [
  (v14/*: any*/),
  (v13/*: any*/)
],
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "seller",
  "storageKey": null,
  "args": null,
  "concreteType": "Seller",
  "plural": false,
  "selections": (v18/*: any*/)
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contemporaryTrackingString",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedPdpUrl",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "classification",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemClassification",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "creationDate",
      "args": null,
      "storageKey": null
    }
  ]
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creators",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCreator",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "attribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creator",
      "storageKey": null,
      "args": null,
      "concreteType": "Creator",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v13/*: any*/)
      ]
    },
    (v13/*: any*/)
  ]
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isArt",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isLinkable",
      "args": null,
      "storageKey": null
    }
  ]
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v28 = [
  (v27/*: any*/)
],
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regionName",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "shipmentQuotes",
  "storageKey": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "totalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": (v28/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "serviceMethod",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "region",
          "storageKey": null,
          "args": null,
          "concreteType": "Region",
          "plural": false,
          "selections": [
            (v29/*: any*/),
            (v13/*: any*/)
          ]
        },
        (v13/*: any*/)
      ]
    },
    (v13/*: any*/)
  ]
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isMultiSku",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "variableAttributes",
  "storageKey": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "variableAttributeData",
      "storageKey": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "swatchSort",
          "storageKey": null,
          "args": null,
          "concreteType": "SwatchSort",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "swatch",
              "storageKey": null,
              "args": null,
              "concreteType": "Swatch",
              "plural": false,
              "selections": [
                (v14/*: any*/),
                (v4/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageUrl",
                  "args": null,
                  "storageKey": null
                },
                (v13/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v13/*: any*/)
  ]
},
v33 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v34 = [
  (v33/*: any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "searchAndBrowse"
  }
],
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v27/*: any*/),
    (v35/*: any*/)
  ]
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayPrice",
  "storageKey": null,
  "args": (v34/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "plural": true,
  "selections": [
    (v36/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantityDisplay",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "percentageOff",
      "args": null,
      "storageKey": null
    },
    (v37/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceVariability",
      "args": null,
      "storageKey": null
    }
  ]
},
v39 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "quickViewDisplay",
  "storageKey": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "alias": "mobileTitle",
      "name": "title",
      "args": (v39/*: any*/),
      "storageKey": "title(formatType:\"MOBILE\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "paragraphs",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "plural": true,
      "selections": [
        (v40/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "text",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": "mobileText",
          "name": "text",
          "args": (v39/*: any*/),
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ]
    }
  ]
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "measurement",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "display",
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "unit",
          "args": null,
          "storageKey": null
        },
        (v42/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "size",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSize",
      "plural": false,
      "selections": [
        (v42/*: any*/)
      ]
    }
  ]
},
v44 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "sellerProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "SellerProfile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "company",
      "args": null,
      "storageKey": null
    }
  ]
},
v45 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "showSeller",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v44/*: any*/)
      ]
    }
  ]
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "placeholder",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "smallPath",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "masterOrZoomPath",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pdpURL",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "Condition",
  "passingValue": false,
  "condition": "isSbTileCarouselTest",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "productPhotos",
      "name": "photos",
      "storageKey": "photos(limit:1)",
      "args": (v11/*: any*/),
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        (v46/*: any*/),
        (v47/*: any*/),
        (v48/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/)
      ]
    },
    (v49/*: any*/)
  ]
},
v51 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "isSbTileCarouselTest",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "carouselPhotos",
      "name": "photos",
      "storageKey": "photos(limit:2)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 2
        }
      ],
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        (v46/*: any*/),
        (v47/*: any*/),
        (v48/*: any*/),
        (v13/*: any*/)
      ]
    }
  ]
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkReference",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hexCode",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkable",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedFilterName",
  "args": null,
  "storageKey": null
},
v57 = [
  (v33/*: any*/)
],
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "photo",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v60 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkText",
  "args": null,
  "storageKey": null
},
v61 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v62 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v63 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryPath",
  "args": null,
  "storageKey": null
},
v64 = {
  "kind": "Literal",
  "name": "first",
  "value": 12
},
v65 = [
  {
    "kind": "Literal",
    "name": "featureName",
    "value": "NON_MVP_SEARCH_BROWSE"
  }
],
v66 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v67 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v68 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v69 = [
  {
    "kind": "Literal",
    "name": "address",
    "value": {
      "country": "us"
    }
  },
  {
    "kind": "Literal",
    "name": "regionBoundaryTypes",
    "value": [
      "METROPOLITAN",
      "DISTRICT",
      "DOMESTIC"
    ]
  },
  {
    "kind": "Literal",
    "name": "regionType",
    "value": "ITEM_LOCATION"
  }
],
v70 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "iconUri",
  "args": null,
  "storageKey": null
},
v71 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v72 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "daysRelativeToExpiration",
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v73 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "benefit",
    "args": null,
    "storageKey": null
  }
],
v74 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  (v64/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "sbRespRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "getDomainLinksSb_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "SbRespLayout_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "detectPageExistsAndRedirect_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "sbRespRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemSearch",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "disableForceFacet",
                "variableName": "disableForceFacet"
              },
              {
                "kind": "Variable",
                "name": "eligibleAbTest",
                "variableName": "eligibleAbTest"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "localeOrigin",
                "variableName": "localeOrigin"
              },
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page"
              },
              {
                "kind": "Variable",
                "name": "regions",
                "variableName": "regions"
              },
              (v1/*: any*/)
            ],
            "concreteType": "ItemSearchQueryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pageType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "languageAnnotations",
                "storageKey": null,
                "args": null,
                "concreteType": "LanguageAnnotations",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "available",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "href",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hrefLang",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayUriRef",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "searchCorrections",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchCorrectionsType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "semanticSearchTerm",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "classificationLevel",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "classificationSearchTerm",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "appliedFilters",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseParsedParam",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "values",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParamValue",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "vanityUriRef",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "topCategoryL1",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalResults",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "browseContentModule",
                "storageKey": null,
                "args": (v6/*: any*/),
                "concreteType": null,
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "moduleType",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "sort",
                "storageKey": null,
                "args": null,
                "concreteType": "SortType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "currentOption",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseSortCurrentOption",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryTiles",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseCategoryTiles",
                "plural": true,
                "selections": (v8/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "meta",
                "storageKey": null,
                "args": null,
                "concreteType": "MetaData",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canonical",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "prev",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "disableIndexing",
                    "args": null,
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "next",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "microdata",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemSearchQueryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSearchResult",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "photos",
                            "storageKey": "photos(limit:1)",
                            "args": (v11/*: any*/),
                            "concreteType": "ItemPhoto",
                            "plural": true,
                            "selections": [
                              (v12/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          (v13/*: any*/)
                        ]
                      },
                      (v13/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pageExists",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "unauthorized",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "redirect",
                "storageKey": null,
                "args": null,
                "concreteType": "redirectType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchSb",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "searchCorrections",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchCorrectionsType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "originalSearchTerm",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "forceSearchUri",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "suggestions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchCorrectionSuggestionsValues",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "uri",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canBeLocationSearch",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canFollowSearch",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "meta",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MetaData",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "header",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "relatedSearchResults",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSearchResultConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSearchResultEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v13/*: any*/),
                                  (v9/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v26/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v38/*: any*/),
                                  (v41/*: any*/),
                                  (v43/*: any*/),
                                  (v45/*: any*/),
                                  (v50/*: any*/),
                                  (v51/*: any*/)
                                ]
                              },
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "appliedFilters",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParam",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "plural": true,
                        "selections": [
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v55/*: any*/)
                        ]
                      },
                      (v56/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canBeDismissed",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "clearAllLinkReference",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "breadcrumbs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseBreadcrumbs",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v25/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "priceTiles",
                    "storageKey": null,
                    "args": (v57/*: any*/),
                    "concreteType": "SearchBrowsePriceTile",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "browseContentModule",
                    "storageKey": null,
                    "args": (v6/*: any*/),
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModuleRegular",
                        "selections": [
                          (v10/*: any*/),
                          (v9/*: any*/),
                          (v58/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModuleBanner",
                        "selections": [
                          (v58/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subtitle",
                            "args": null,
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModulePromo",
                        "selections": [
                          (v58/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pillText",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "headline",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subtext",
                            "args": null,
                            "storageKey": null
                          },
                          (v59/*: any*/),
                          (v60/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModuleIconicDesign",
                        "selections": [
                          (v10/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "mainImage",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "categoryTiles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseCategoryTiles",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "itemId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "rank",
                        "args": null,
                        "storageKey": null
                      },
                      (v61/*: any*/),
                      (v62/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "masterImage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayMaxNumberOfPages",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clearAppliedFiltersLinkReference",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "filters",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilter",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v56/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseFilterValue",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v52/*: any*/),
                          (v55/*: any*/),
                          (v35/*: any*/),
                          (v54/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "stats",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "stats",
                            "plural": true,
                            "selections": [
                              (v40/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "values",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v5/*: any*/),
                          (v53/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalCount",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isAttributePage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sort",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SortType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "options",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortAvailableOptions",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v52/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currentOption",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortCurrentOption",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "searchTerm",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSearchQueryEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSearchResult",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v9/*: any*/),
                              (v63/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v20/*: any*/),
                              (v17/*: any*/),
                              (v19/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": "displayPriceTracking",
                                "name": "displayPrice",
                                "storageKey": null,
                                "args": (v34/*: any*/),
                                "concreteType": "ItemDisplayPriceType",
                                "plural": true,
                                "selections": [
                                  (v36/*: any*/),
                                  (v37/*: any*/)
                                ]
                              },
                              (v30/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v26/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              (v38/*: any*/),
                              (v41/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "relatedItems",
                    "name": "thinBrowseRelatedItems",
                    "storageKey": "thinBrowseRelatedItems(first:12,seller:\"INCLUDE\")",
                    "args": [
                      (v64/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "seller",
                        "value": "INCLUDE"
                      }
                    ],
                    "concreteType": "itemSearchMoreLikeThisConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "itemSearchMoreLikeThisEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v9/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v26/*: any*/),
                              (v17/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              (v38/*: any*/),
                              (v41/*: any*/),
                              (v43/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "showSeller",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "seller",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Seller",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v44/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v50/*: any*/),
                              (v51/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "internalBuyLinks",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "anchorText",
                        "args": null,
                        "storageKey": null
                      },
                      (v61/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "priceTiles",
                        "storageKey": null,
                        "args": (v57/*: any*/),
                        "concreteType": "SearchBrowsePriceTile",
                        "plural": true,
                        "selections": [
                          (v35/*: any*/),
                          (v62/*: any*/),
                          (v61/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "facets",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseFacets",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "location",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FacetValueType",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "label",
                                "args": null,
                                "storageKey": null
                              },
                              (v13/*: any*/)
                            ]
                          },
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isBillboardAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isThinItemSearchEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMoreWaysToBrowseEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFollowSearchEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isShopByRoomEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SHOP_BY_ROOM"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbRespFollowSearchEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "disableFollowSearchStickyBanner",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableFollowSearchStickyBanner"
              }
            ],
            "storageKey": "isEnabled(key:\"disableFollowSearchStickyBanner\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabledByLocale",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbMobileGridToggleDisabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "isSbMobileGridToggleDisabled"
              }
            ],
            "storageKey": "isEnabled(key:\"isSbMobileGridToggleDisabled\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isContentModuleEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "BROWSE_CONTENT_MODULES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSkyscraperAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbSharedRefineMenuSearchWithinEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMatchedSetsEnabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "enableMatchedSetsFacet"
              }
            ],
            "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSearchWithinFilterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "REFINE_MENU_SEARCH"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isDeliveryOptionsDisabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
          },
          {
            "kind": "LinkedField",
            "alias": "locations",
            "name": "itemFacetSearch",
            "storageKey": null,
            "args": [
              (v66/*: any*/),
              {
                "kind": "Literal",
                "name": "facetName",
                "value": "location"
              },
              (v67/*: any*/),
              {
                "kind": "Literal",
                "name": "getExactMatches",
                "value": false
              },
              {
                "kind": "Literal",
                "name": "page",
                "value": 1
              },
              (v1/*: any*/),
              (v68/*: any*/)
            ],
            "concreteType": "ItemFacetsQueryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemFacetsQueryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FilterValueType",
                    "plural": false,
                    "selections": [
                      (v54/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v52/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSeoQuicklookEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEO_QUICKLOOK"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isTileAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": (v65/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isVisuallySimilarEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "VISUALLY_SIMILAR"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isTradeDoubleClickAdsOnSbDisabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableTradeDoubleClickAdsOnSB"
              }
            ],
            "storageKey": "isEnabled(key:\"disableTradeDoubleClickAdsOnSB\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contactInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "ContactInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "phoneNumbers",
                "storageKey": null,
                "args": null,
                "concreteType": "support",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "tradeSupport",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "formatType",
                        "value": "INTERNATIONAL"
                      }
                    ],
                    "storageKey": "tradeSupport(formatType:\"INTERNATIONAL\")"
                  }
                ]
              }
            ]
          },
          (v13/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchRegionalInfo",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regionalInfo",
                "storageKey": null,
                "args": [
                  (v66/*: any*/),
                  (v68/*: any*/)
                ],
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "regionsByZipCode",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  },
                  (v13/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": "isSbTradeFreeShippingTestDisabled",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disableSbTradeFreeShippingTest"
                  }
                ],
                "storageKey": "isEnabled(key:\"disableSbTradeFreeShippingTest\")"
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regions",
                "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")",
                "args": (v69/*: any*/),
                "concreteType": "Region",
                "plural": true,
                "selections": [
                  (v29/*: any*/),
                  (v3/*: any*/),
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "parentPrograms",
                    "name": "tradeProgramsQuery",
                    "storageKey": "tradeProgramsQuery(programCodes:[\"MEMBER\",\"BRONZE\",\"SILVER\",\"GOLD\",\"PLATINUM\"])",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "programCodes",
                        "value": [
                          "MEMBER",
                          "BRONZE",
                          "SILVER",
                          "GOLD",
                          "PLATINUM"
                        ]
                      }
                    ],
                    "concreteType": "LoyaltyProgram",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v4/*: any*/),
                      (v70/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "maxPoints",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "minPoints",
                        "args": null,
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "regions",
                    "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")",
                    "args": (v69/*: any*/),
                    "concreteType": "Region",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "regionBoundary",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RegionBoundary",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "type",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RegionBoundaryType",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isClient",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shippingFilters",
                    "storageKey": null,
                    "args": [
                      (v66/*: any*/),
                      (v1/*: any*/),
                      (v68/*: any*/)
                    ],
                    "concreteType": "ShippingFilterType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v71/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "favorites",
                    "storageKey": null,
                    "args": [
                      (v67/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "pages",
                        "variableName": "followSearchPages"
                      },
                      {
                        "kind": "Variable",
                        "name": "types",
                        "variableName": "followSearchTypes"
                      }
                    ],
                    "concreteType": "favoritesConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "favoritesEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Favorite",
                            "plural": false,
                            "selections": (v18/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "measurementUnit",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canShowSellerName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canShowInternalSellerName",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "VIEW_SELLER_NAME"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "showStrategicPartnerFilter",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "STRATEGIC_PARTNER_FILTERING"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"STRATEGIC_PARTNER_FILTERING\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "verifiedTradeStatus",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVip",
                    "args": null,
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "expiringPromotion",
                        "storageKey": "expiringPromotion(daysToExpiration:14,promoCodes:[\"TRADEWELCOME\",\"SHIP2019\",\"RISKFREE\"])",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 14
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "SHIP2019",
                              "RISKFREE"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "plural": false,
                        "selections": [
                          (v72/*: any*/),
                          (v5/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rewards",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "educationMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v73/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pointsToMaintainStatus",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pointsMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v73/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "homepageMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v73/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "postCheckoutMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v73/*: any*/)
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tpnRole",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmTPNRole",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isTrade",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "loyalty",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmLoyaltyType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentYearSpend",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "plural": false,
                                    "selections": (v28/*: any*/)
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "rewards",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmRewards",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentProgram",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "programInfo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v4/*: any*/),
                                          (v70/*: any*/),
                                          (v13/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "nextProgram",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "programInfo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v70/*: any*/),
                                          (v13/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmRewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentPromoSegment",
                            "storageKey": null,
                            "args": (v71/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "promotion",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "buyerExpirationDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "endDate",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "dateOnly",
                                        "value": true
                                      }
                                    ],
                                    "storageKey": "endDate(dateOnly:true)"
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "expiringPromoSegment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "expiringSegmentCode",
                                "args": null,
                                "storageKey": null
                              },
                              (v72/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUserRecentHistoryItem",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "storageKey": null,
                        "args": (v74/*: any*/),
                        "concreteType": "RecentHistoryItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RecentHistoryItemsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstPhotoWebPath",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "size",
                                        "value": "small"
                                      }
                                    ],
                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                  },
                                  (v49/*: any*/),
                                  (v9/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v14/*: any*/),
                                  (v63/*: any*/),
                                  (v19/*: any*/),
                                  (v13/*: any*/),
                                  (v7/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "args": (v74/*: any*/),
                        "handle": "connection",
                        "key": "getRecentHistory_recentHistoryItems",
                        "filters": [
                          "excludeItemPks"
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "sbRespRootQuery",
    "id": "app-buyer-finding/254.0.0-2020-03-04T19:26:20.366Z/sbRespRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '148d57e65680b6a26827bb8c25a3c919';
export default node;
